import VerificationStatistic from './VerificationStatistic';

export default VerificationStatistic;
